import AdminDashboard from "pages/dashboard/AdminDashboard";
import Products from "pages/dashboard/Products";
import Posts from "pages/dashboard/Posts";
import Orders from "pages/dashboard/Orders";
import Accounts from "pages/dashboard/Accounts";
import Settings from "pages/dashboard/Settings";
import Reports from "pages/dashboard/Reports";
import Comments from "pages/dashboard/Comments";
import Coupons from "pages/dashboard/Coupons";

import UserDashboard from "pages/dashboard/UserDashboard";

import {
  SettingFilled,
  ShoppingCartOutlined,
  AreaChartOutlined,
  DollarOutlined,
  HomeOutlined,
  DatabaseOutlined,
  CommentOutlined,
  PercentageOutlined,
  PicRightOutlined,
} from "@ant-design/icons";

export const adminRoutes = [
  {
    name: "داشبورد",
    link: "/dashboard/index",
    component: AdminDashboard,
    icon: <HomeOutlined />,
  },
  {
    name: "محصولات",
    link: "/dashboard/products",
    component: Products,
    icon: <DatabaseOutlined />,
  },
  {
    name: "سفارش ها",
    link: "/dashboard/orders",
    component: Orders,
    icon: <ShoppingCartOutlined />,
  },
  {
    name: "نظرات",
    link: "/dashboard/comments",
    component: Comments,
    icon: <CommentOutlined />,
  },
  {
    name: "پست ها",
    link: "/dashboard/posts",
    component: Posts,
    icon: <PicRightOutlined />,
  },
  {
    name: "کد تخفیف",
    link: "/dashboard/coupons",
    component: Coupons,
    icon: <PercentageOutlined />,
  },

  // {
  //   name: "پرداخت ها",
  //   link: "/dashboard/accounts",
  //   component: Accounts,
  //   icon: <DollarOutlined />,
  // },
  // {
  //   name: "گزارشات",
  //   link: "/dashboard/reports",
  //   component: Reports,
  //   icon: <AreaChartOutlined />,
  // },
  {
    name: "تنظیمات",
    link: "/dashboard/settings",
    component: Settings,
    icon: <SettingFilled />,
  },
];
export const userRoutes = [
  {
    name: "داشبورد",
    link: "/dashboard/index",
    component: UserDashboard,
    icon: <HomeOutlined />,
  },
];
